// Helpers for the ACv2 impact band (EO-1217). Kept out of the component per the repo rule that
// utility functions live in a module utils file, not inside components.

/**
 * Safe bar widths (percent strings) for a market_gap band's you/benchmark values, each scaled to
 * the larger of the two so the bigger value fills the track. Non-numeric, null or non-positive
 * values yield "0%" (an empty bar) — never a NaN width, which the browser would drop and render
 * as a full 100% bar.
 *
 * @param {{you?: number|string, benchmark?: number|string}} gap
 * @returns {{you: string, benchmark: string}} percent strings for CSS `--acb-bar-width`
 */
export const gapBarWidths = (gap = {}) => {
  const you = Number(gap.you);
  const benchmark = Number(gap.benchmark);
  const max = Math.max(
    Number.isFinite(you) ? you : 0,
    Number.isFinite(benchmark) ? benchmark : 0
  );

  const toWidth = (value) => {
    if (!Number.isFinite(value) || value <= 0 || max <= 0) return "0%";
    return `${Math.min(100, (value / max) * 100)}%`;
  };

  return { you: toWidth(you), benchmark: toWidth(benchmark) };
};
